import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    background: {
      default: '#fff',
    },
    primary: {
      main: '#24A2B5',
      light: '#4FB9C6',
      dark: '#1B7A87',
    },
    grey: {
      500: '#516075',
    },
    text: {
      primary: '#24303F',
      secondary: '#516075',
    },
  },
});
